module.exports = __webpack_public_path__ + "static/media/background_1920-18.acfe7046.jpg";